module.exports = __webpack_public_path__ + "static/media/pin.360e60c1.svg";